module.exports = __webpack_public_path__ + "static/media/forward.d974d580.svg";